module.exports = __webpack_public_path__ + "img/example-03-original.d0c60666.jpg";